import { Component, OnInit, Input, AfterViewInit, OnDestroy, Output, EventEmitter } from '@angular/core';

import * as Services from '@shared/core/services';
import * as State from '@shared/state';
import { Controllers } from '@shared/core/controllers';

// import { ScrollService } from '@shared/core/directives';

import { Observable, Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import * as selectors from '@shared/state/selectors';
import { Store, select } from '@ngrx/store';

@Component({
    selector: 'shared-auth',
    templateUrl: './auth.shared.component.html',
    styleUrls: ['./auth.shared.component.scss']
})
export class AuthComponent implements OnInit, AfterViewInit, OnDestroy {
    @Input() public locationNo: number = null;
    @Input() public memberId: number = null;
    @Input() public orderId: number = null;
    @Input() public modalData: State.IModal = null;

    @Output() public onUpdate: EventEmitter<OLO.Enums.AUTH_STEP> = new EventEmitter();

    public authenticationStep$: Observable<OLO.Enums.AUTH_STEP>;
    public loyaltyAppDataReady$: Observable<boolean>;
    public stepChangesListener$: Subscription;

    constructor(
        public controllers: Controllers,
        public membersService: Services.MembersService,
        private _store: Store<State.IStateShared>,
    ) { }

    ngOnInit(): void {
        this.authenticationStep$ = this.controllers.members.getAuthenticationStep$();

        this.stepChangesListener$ = this.controllers.members.getAuthenticationStep$()
            .subscribe(step => {
                this.onUpdate.emit(step);
            });

        this.loyaltyAppDataReady$ = this._store.pipe(select(selectors.getLoyaltyAppDataReady));
    }

    ngAfterViewInit(): void {
        setTimeout(() => {
            this.onUpdate.emit();
        }, 0);
    }

    ngOnDestroy(): void {
        if (this.stepChangesListener$ && !this.stepChangesListener$.closed) this.stepChangesListener$.unsubscribe();
        this.controllers.members.resetMemberDataFields();

        // When auth component is 'complete' (aka modal is closed), all member sign up/sign in data should be reset to defaults
        // Logic is controlled inside effects or in some cases by services.
        //
        // Case 1 and two are duplications but step 2 changes only auth step without resetting member's previous flow. We don't need that
        // Case 3 is a misunderstanding. JwtSuccess action is dispatched directly without any logic and checks. By default Birthday step is set. Why?
        // How do you know someone has a birthday?
        // All these are controlled by effects. This has no right to work. It looks like a patch to some specific scenario that I'm not aware of
        // or had been forced to implement added ad hoc - if so, than this new feature should be handled differently.
        // Avoid dispatching actions directly from components. Create a proper controller method that can combine selectors and additional logic to calculate
        // final actions. Otherwise you will end up with buisness logic inside components.
        // this.controllers.members.getAuthenticationStep$().pipe(
        //     take(1)
        // ).subscribe(step => {
        //     switch (true) {
        //         case step === OLO.Enums.AUTH_STEP.LOGIN:
        //             return this.controllers.members.resetMemberDataFields();
        //         case step === OLO.Enums.AUTH_STEP.REGISTER_SUCCESS:
        //             return this.controllers.members.setAuthStep(OLO.Enums.AUTH_STEP.LOGIN);
        //         case step === OLO.Enums.AUTH_STEP.UPDATE_SUCCESS: {
        //             this._store.dispatch(actions.MemberJwtDataResponseSuccess({ email: null, password: null }));
        //             return this.controllers.members.setAuthStep(OLO.Enums.AUTH_STEP.BIRTHDAY_REWARDS);
        //         }
        //         default:
        //             return;
        //     }
        // });
    }

    public handleBackClick($event: Event): void {
        this.controllers.members.getAuthenticationStep$()
            .pipe(
                take(1)
            )
            .subscribe(step => {
                switch (true) {
                    case step === OLO.Enums.AUTH_STEP.FORGOT_PASSWORD:
                    case step === OLO.Enums.AUTH_STEP.PASSWORD:
                    case step === OLO.Enums.AUTH_STEP.REGISTER:
                    case step === OLO.Enums.AUTH_STEP.ACCOUNT_LINKING_REWARDS_INFO:
                    case step === OLO.Enums.AUTH_STEP.ACCOUNT_LINKING_REWARDS_SIGN_UP:
                        return this.controllers.members.setAuthStep(OLO.Enums.AUTH_STEP.LOGIN);

                    case step === OLO.Enums.AUTH_STEP.VERIFY_EMAIL:
                    case step === OLO.Enums.AUTH_STEP.VERIFY_PHONE:
                        return this.controllers.members.setAuthStep(OLO.Enums.AUTH_STEP.REGISTER);
                    default:
                        return;
                }
            });
    }
}
